import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReferralsComponent } from './referrals/referrals.component';
import { ReferPatientComponent } from './refer-patient/refer-patient.component';
import { PhysicianLayoutComponent } from '../physician/layout/physician-layout.component';

const routes: Routes = [
  {
    path: 'Referrals',
    component: PhysicianLayoutComponent,
    children: [
      { path: '', component: ReferralsComponent },
      { path: ':id', component: ReferPatientComponent }
    ]
  }];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class ReferralRoutingModule { }
